import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import ModuleComponent from "../components/ModuleComponent/Module.component";
import KnowledgeIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_gestio.png'
import KnowledgeIconDark from './../utils/resources/ModuleIcons/NewIconsDark/moduls_gestio.png'
import AdministrationIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_administration.png'
import AdministrationIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_administration-05.png'
import MonitoringIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_monitoring.png'
import MonitoringIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_monitoring-06.png'
import ProductionIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_production.png'
import ProductionIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_production-07.png'
import AlarmsIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_alarms.png'
import AlarmsIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_alarms-10.png'
import ReportingIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_reports.png'
import ReportingIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_reports-08.png'
import APIIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_api.png'
import APIIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_api-11.png'
import UpdateIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_software.png'
import UpdateIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_software-19.png'
import AnalyticIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_analytics.png'
import AnalyticIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_analytics-09.png'
import DigitalTwinIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_twin.png'
import DigitalTwinIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_digital twin.png'
import D3Icon from './../utils/resources/ModuleIcons/NewIcons/moduls_3D.png'
import D3IconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_3D-18.png'
import RegistringIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_automatic setup.png'
import RegistringIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_automatic set up.png'
import PaymentIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_payment.png'
import PaymentIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_payment.png'
import AsistancesIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_intervention.png'
import AsistancesIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_intervention-17.png'
import MarketingIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_marketing.png'
import MarketingIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_marketing-15.png'
import EndUserIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_end user.png'
import EndUserIconDark from './../utils/resources/ModuleIcons/NewIconsDark/modul_end user-13.png'
import LogsIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_registros.png'
import LogsIconDark from './../utils/resources/ModuleIcons/NewIconsDark/moduls_registro.png'
import CAEIcon from './../utils/resources/ModuleIcons/NewIcons/moduls_cae.png'
import CAEIconDark from './../utils/resources/ModuleIcons/NewIconsDark/moduls_cae.png'
import { useTheme } from "../utils/contexts/ThemeContext";

const ModulesPage = () => {
    const { t } = useTranslation();
    const context: IOutletContext = useOutletContext();
    const theme = useTheme()

    const moduleLinks = [
        {
            name: t('Administration'),
            route: 'machines',
            icon: theme.theme === "dark" ? AdministrationIcon : AdministrationIconDark,
            disabled: false
        },
        {
            name: t('Monitoring'),
            route: 'home',
            icon: theme.theme === "dark" ? MonitoringIcon : MonitoringIconDark,
            disabled: false
        },
        {
            name: t('Production'),
            route: 'modules/production',
            icon: theme.theme === "dark" ? ProductionIcon : ProductionIconDark,
            disabled: false
        },
        {
            name: t('Alarms'),
            route: 'modules/alarms',
            icon: theme.theme === "dark" ? AlarmsIcon : AlarmsIconDark,
            disabled: false
        },
        {
            name: t('ReportsAndBilling'),
            route: 'modules/reporting',
            icon: theme.theme === "dark" ? ReportingIcon : ReportingIconDark,
            disabled: false
        },
        {
            name: t('API'),
            route: 'modules/api',
            icon: theme.theme === "dark" ? APIIcon : APIIconDark,
            disabled: false
        },
        {
            name: t('RemoteUpdate'),
            route: 'modules/update',
            icon: theme.theme === "dark" ? UpdateIcon : UpdateIconDark,
            disabled: false
        },
        {
            name: t('Analytics'),
            route: 'modules/analytic',
            icon: theme.theme === "dark" ? AnalyticIcon : AnalyticIconDark,
            disabled: false
        },
        {
            name: t('DigitalTwin'),
            route: 'userMachines?isModule=1',
            icon: theme.theme === "dark" ? DigitalTwinIcon : DigitalTwinIconDark,
            disabled: false
        },
        {
            name: t('3D'),
            route: 'modules/3d',
            icon: theme.theme === "dark" ? D3Icon : D3IconDark,
            disabled: false
        },
        {
            name: t('AutomaticSetup'),
            route: 'modules/autoregistring',
            icon: theme.theme === "dark" ? RegistringIcon : RegistringIconDark,
            disabled: true
        },
        {
            name: t('LicencesAndPayment'),
            route: 'modules/payment',
            icon: theme.theme === "dark" ? PaymentIcon : PaymentIconDark,
            disabled: false
        },
        {
            name: t('InterventionTracking'),
            route: 'modules/asistances',
            icon: theme.theme === "dark" ? AsistancesIcon : AsistancesIconDark,
            disabled: false
        },
        {
            name: t('EndUser'),
            route: 'modules/enduser',
            icon: theme.theme === "dark" ? EndUserIcon : EndUserIconDark,
            disabled: false
        },
        {
            name: t('Marketing'),
            route: 'modules/marketing',
            icon: theme.theme === "dark" ? MarketingIcon : MarketingIconDark,
            disabled: true

        },
        {
            name: t('Knowledge'),
            route: 'modules/knowledge',
            icon: theme.theme === "dark" ? KnowledgeIcon : KnowledgeIconDark,
            disabled: false
        },
        {
            name: t('LogsAndAudit'),
            route: 'modules/logs',
            icon: theme.theme === "dark" ? LogsIcon : LogsIconDark,
            disabled: false,
            resize: true
        },
        {
            name: 'CAE',
            route: 'modules/cae',
            icon: theme.theme === "dark" ? CAEIcon : CAEIconDark,
            disabled: false,
            resize: true
        }
    ]


    useEffect(() => {
        context.setState(t('Modules'));
    }, [context, t]);


    const containerStyle: React.CSSProperties = {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        gap: '1.25rem',
        justifyContent: "center"
    }

    return (
        <div className="p-3">
            <div style={containerStyle}>
                {
                    moduleLinks.map((m, k) =>
                        <ModuleComponent key={k} icon={m.icon} name={m.name} route={m.route} disabled={m.disabled} resize={m.resize} />
                    )
                }
            </div>
        </div>
    );
};

export default ModulesPage;
